<button
  class="tag {{ color() }} size-{{ size() }}"
  [class.disabled]="disabled()"
  [class.inactive]="inactive()"
  [tabIndex]="inactive() || disabled() ? -1 : 0"
>
  @if (loading()) {
    <onyx-spinner [size]="16" color="current"></onyx-spinner>
  } @else {
    @if (icon(); as icon) {
      <onyx-icon [name]="icon" [size]="16"></onyx-icon>
    } @else if (flag()) {
      <onyx-flag [countryCode]="flag()!" [size]="16"></onyx-flag>
    }

    <ng-content></ng-content>

    @if (count() != null) {
      <span class="count">{{ count() | number: '1.0-0' }}</span>
    }
  }
</button>
